class LoaderService {
    _subscribers = [];

    show = () => this._notify(true);
    hide = () => this._notify(false);

    subscribe = (callback) => {
        this._subscribers.push(callback);
        return () => {
            this._subscribers = this._subscribers.filter((cb) => cb !== callback);
        };
    };

    _notify = (value) => {
        this._subscribers.forEach((cb) => cb(value));
    };
}

const loaderService = new LoaderService();
export default loaderService;
